export const styles = {
  height: '100vh',
  width: '100vw',
  backgroundColor: 'rgba(0,0,0,1)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 9999,
} as React.CSSProperties
